<p-toast />

<div class="version-container">
    <div class="version-wrapper">
        <div class="version-content">
            <div class="grid py-5">
                <div class="col-12">
                    <h2>Application Version Information</h2>
                    <p-table [value]="versionInfo" [tableStyle]="{ 'min-width': '60rem' }" [loading]="isLoading">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Property</th>
                                <th>Value</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-info>
                            <tr>
                                <td>{{ info.name }}</td>
                                <td>{{ info.value }}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="2" class="text-center"><b>No Version Information Available.</b></td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>

            <div class="grid py-3">
                <div class="col-12">
                    <div class="health-check-section">
                        <div class="health-check-header">
                            <h2>Backend Health Check</h2>
                            <button pButton
                                    icon="pi pi-refresh"
                                    class="p-button-rounded p-button-text"
                                    (click)="refreshHealthCheck()"
                                    [disabled]="isPingLoading"
                                    pTooltip="Refresh health check data"></button>
                        </div>

                        <p-progressBar *ngIf="isPingLoading" mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>

                        <div *ngIf="pingError" class="health-check-error">
                            <i class="pi pi-exclamation-triangle"></i>
                            <span>{{ pingError }}</span>
                        </div>

                        <div *ngIf="!isPingLoading && !pingError && healthCheckResults">
                            <p-table [value]="[
                                { name: 'Status', value: healthCheckResults.status },
                                { name: 'Server Time', value: healthCheckResults.timestamp },
                                { name: 'Package Version', value: healthCheckResults.versions.package},
                                { name: 'App Version', value: healthCheckResults.versions.npmApp},
                                { name: 'Compiled Version', value: healthCheckResults.versions.compiled},
                                { name: 'Last Compiled', value: healthCheckResults.lastCompileTimestamp},
                                { name: 'Launch Time', value: healthCheckResults.launchTimestamp},
                                { name: 'NPM Lifecycle Event', value: healthCheckResults.npmLifecycleEvent},
                                { name: 'PM2 ID', value: healthCheckResults.pm2Info.pm_id},
                                { name: 'PM2 Name', value: healthCheckResults.pm2Info.name}
                            ]" [tableStyle]="{ 'min-width': '60rem' }">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Property</th>
                                        <th>Value</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-info>
                                    <tr>
                                        <td>{{ info.name }}</td>
                                        <td>{{ info.value }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
